exports = module.exports = require("../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.g-rotate-bar{\n    position: absolute;\n    bottom: 30px;\n    left: 0;\n    right: 0;\n    text-align: center;\n}\n.g-rotate-bar .svg-icon{\n  display: inline-block;\n  width: 1.2em;\n  height: 1.2em;\n  margin: 0 2em;\n}\n", "", {"version":3,"sources":["/Users/henian/code/front-end/ziying/Website/node_modules/vue-core-image-upload/dist/rotate-bar.vue"],"names":[],"mappings":";AACA;IACI,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,SAAS;IACT,mBAAmB;CACtB;AACD;EACE,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,cAAc;CACf","file":"rotate-bar.vue","sourcesContent":["\n.g-rotate-bar{\n    position: absolute;\n    bottom: 30px;\n    left: 0;\n    right: 0;\n    text-align: center;\n}\n.g-rotate-bar .svg-icon{\n  display: inline-block;\n  width: 1.2em;\n  height: 1.2em;\n  margin: 0 2em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/vue-core-image-upload/dist/rotate-bar.vue
// module id = Bh49
// module chunks = 0